export enum GenericChartScreen {
  None = 0,
  PaymentsPieChart = 1,
}



// WEBPACK FOOTER //
// ./src/app/admin/charts/models/GenericChartScreen.ts